import { provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { APP_INITIALIZER, NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { ServiceWorkerModule } from '@angular/service-worker';
import { CoreModule } from '../app/core/core.module';
import { environment } from '../environments/environment';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { Constants } from './shared/providers/data';
/* #Region remote data server for demo purposes only */
import { HttpClientInMemoryWebApiModule } from 'angular-in-memory-web-api';
import { InMemoryMenuService } from '../app/core/http/remote server/in-memory.data.service';
/* #endRegion */
import { MAT_FORM_FIELD_DEFAULT_OPTIONS } from '@angular/material/form-field';
import { DialogModule } from '@ds/ng-wt-dialog';
import { SgWebHttpModule } from '@ds/ng-wt-helpers/http';
import { HotToastModule } from '@ngneat/hot-toast';
import { WelcomeComponent } from './welcome/welcome.component';
import { SharedModule } from './shared/shared.module';
import { firstValueFrom } from 'rxjs';
import { TranslocoService } from '@jsverse/transloco';
import { AmplifyAuthenticatorModule } from '@aws-amplify/ui-angular';
import { DecimalPipe } from '@angular/common';
import { DialogCleanupService } from './core/authentication/dialog-cleanup.service';
import { RefreshTokenValidationService } from './core/authentication/refresh-token-validation.service';

export function translationTemplateLoader(transloco: TranslocoService) {
  return function () {
    transloco.setActiveLang('en');
    return firstValueFrom(transloco.load('en'));
  };
}
export const preLoadTranslationTemplate = {
  provide: APP_INITIALIZER,
  multi: true,
  useFactory: translationTemplateLoader,
  deps: [TranslocoService],
};

@NgModule({
  declarations: [AppComponent, WelcomeComponent],
  bootstrap: [AppComponent,],
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    CoreModule,
    AppRoutingModule,
    SharedModule,
    AmplifyAuthenticatorModule,
    /* The HttpClientInMemoryWebApiModule module intercepts HTTP requests
           and returns simulated server responses.
           Remove it when a real server is ready to receive requests.*/
    environment.production
      ? []
      : HttpClientInMemoryWebApiModule.forRoot(InMemoryMenuService, {
          passThruUnknownUrl: true,
        }),
    ServiceWorkerModule.register('/ngsw-worker.js', {
      enabled: environment.production,
    }),
    SgWebHttpModule.forRoot(),
    DialogModule.forRoot({
      enableClose: false,
    }),
    HotToastModule.forRoot({
      reverseOrder: true,
      visibleToasts: 5,
      dismissible: true,
      autoClose: true,
      duration: 5000,
      position: 'top-right',
      success: { className: 'hot-toast-bar-base-success' },
      error: { className: 'hot-toast-bar-base-error' },
      warning: { className: 'hot-toast-bar-base-warning' },
      info: { className: 'hot-toast-bar-base-info' },
    })
  ],
  providers: [
    Constants,
    {
      provide: MAT_FORM_FIELD_DEFAULT_OPTIONS,
      useValue: { appearance: 'outline' },
    },
    provideHttpClient(withInterceptorsFromDi()),
    preLoadTranslationTemplate,
    DecimalPipe,
    DialogCleanupService,
    RefreshTokenValidationService
  ],
})
export class AppModule {}
